/* MARQUE v43: accessible back-to-top, supported on Horizon's desktop scroll container. */
(() => {
  'use strict';
  const button = document.querySelector('[data-marque-back-top]');
  if (!button) return;
  const scroller = document.querySelector('.page-wrapper');
  let scheduled = false;
  const top = () => Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, scroller?.scrollTop || 0);
  function update() {
    scheduled = false;
    button.hidden = top() < 680;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  if (scroller) scroller.addEventListener('scroll', schedule, { passive: true });
  button.addEventListener('click', () => {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior });
    if (scroller) scroller.scrollTo({ top: 0, behavior });
  });
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
